import { render, staticRenderFns } from "./laboratory_brief.vue?vue&type=template&id=71e31e62&scoped=true"
import script from "./laboratory_brief.vue?vue&type=script&lang=js"
export * from "./laboratory_brief.vue?vue&type=script&lang=js"
import style0 from "./laboratory_brief.vue?vue&type=style&index=0&id=71e31e62&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e31e62",
  null
  
)

export default component.exports